import {PointCloudManager} from "../pointcloud";
import MeasurementController from "./measurement-controller";
import {
  MeasurementArea,
  MeasurementLine,
  MeasurementPoint,
  MeasurementVolume,
  SnapDownMeasurement,
  SnapUpMeasurement,
} from "./measurement";

export default class MeasurementConstructor {
  private controller: MeasurementController;
  private pointCloud: PointCloudManager;
  private MeasurementClass
  public measurement;
  private type = null;
  public isFinished = false;

  constructor(controller, pointCloud) {
    this.controller = controller;
    this.pointCloud = pointCloud;

    this.MeasurementClass = MeasurementLine;
    this.measurement = new this.MeasurementClass();
  }

  get activeMeasurement() {
    return this.measurement.vertices.length > 0;
  }

  setBuilder(builderType) {
    this.type = builderType;

    if (builderType === 'snap-up') {
      this.MeasurementClass = SnapUpMeasurement;
    } else if (builderType === 'snap-down') {
      this.MeasurementClass = SnapDownMeasurement;
    } else if (builderType === 'single-point') {
      this.MeasurementClass = MeasurementPoint;
    } else if (builderType === 'area') {
      this.MeasurementClass = MeasurementArea;
    } else if (builderType === 'volume') {
      this.MeasurementClass = MeasurementVolume;
    } else {
      this.MeasurementClass = MeasurementLine;
    }

    this.measurement = new this.MeasurementClass();
    this.measurement.setController(this.controller);
  }

  getMeasurement() {
    if (this.isFinished) {
      let finishedMeasurement = this.measurement;

      this.measurement = new this.MeasurementClass();
      this.measurement.setController(this.controller);

      this.isFinished = false;

      return finishedMeasurement;
    }

    return this.measurement;
  }

  reset() {
    this.isFinished = false;
    this.measurement.vertices = [];
  }

  add(vertex) {
    if (!this.isFinished) {
      let result = this.measurement.add(vertex, this);
      this.isFinished = result.finished;
      return result;
    }
    return {
      added: false,
      valid: false
    };
  }
}
